<template>
    <div>
        <div v-if="options_loaded && passed_filter && panel_required">
            <template v-if="filtered_option_list.length > 0 && filtered_option_list[0].value !== null">
                <div class="designeroption" :data-designer-component-id="component_id">
                    <h3>{{ title }}</h3>
                    <div class="stylesoption selectoption form-group">
                        <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
                            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                        </select>
                        <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
                            <option>Loading Options...</option>
                        </select>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionHardwareKnockerPosition from "../DesignerQuestionHardwareKnockerPosition.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareKnockerPosition
        ],
        props: {
            title: {
                default(){
                    return 'Choose your Knocker Position';
                }
            },
            component_id: {
                default(){
                    return 'hardware_knocker_position';
                }
            },
        },
        computed: {
            panel_required() {
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
            },
        },
    }
</script>
